<template>
	<!-- Usa la pantalla de carga oficial (HyFLoader).
	     relative → tapa solo al contenedor; si no, pantalla completa. -->
	<HyFLoader v-if="$attrs.show !== false" :variant="relative ? 'overlay' : 'fullscreen'" />
</template>

<script>
import HyFLoader from '@/components/Loader/HyFLoader.vue';

export default {
	name: "Loader",
	components: { HyFLoader },
	props: {
		relative: {
			type: Boolean,
			default: false
		}
	}
};
</script>
